import { ETelemetryEvents, TAppTelemetryLogger } from '../../../types/telemetry';

export function getTelemetryBySource(telemetry: TAppTelemetryLogger, source: string) {
  return {
    increment: (telemetryEvent: ETelemetryEvents) => {
      const telemetryKey = `${telemetryEvent}.${source}`;

      telemetry.increment(telemetryKey);
    },
    timing: (telemetryEvent: ETelemetryEvents, value: number) => {
      const telemetryKey = `${telemetryEvent}.${source}`;

      telemetry.timing(telemetryKey, value);
    },
  };
}
